import { InformationModal } from '../InformationModal';
import { Trans, useTranslation } from 'react-i18next';
import { AutomaticSteps } from './components/AutomaticSteps';
import { type CustomInformationModalProps } from 'src/modules/SaldoView/types';
import { useAutomaticInformation } from './hooks';

export const AutomaticInformationModal = ({ closeModal, selectedCompanyId }: CustomInformationModalProps) => {
  const { t } = useTranslation('overview');
  const { mandateData, selfFundingDirectDebitIban, calculationDay } = useAutomaticInformation(selectedCompanyId);

  return (
    <InformationModal
      closeModal={closeModal}
      selectedCompanyId={selectedCompanyId}
      title={t('self funding.automatic recharge')}
      description={
        <Trans i18nKey={'self funding.automatic recharge description'} ns="overview" components={[<strong />]} />
      }
      initialValues={{
        mandatePdfUrl: mandateData?.mandatePdfUrl ?? '',
        selfFundingDirectDebitIban: selfFundingDirectDebitIban ?? '',
        date: calculationDay ?? ''
      }}
      StepsComponent={AutomaticSteps}
      footerText={t('self funding.automatic recharge footer')}
    />
  );
};
